export default __webpack_public_path__ + "static/media/6C1_at_2020-13-2.3b7add23.png";